import csv from './importers/csv.js';
import json from './importers/json.js';
import array from './importers/array.js';
import xlsx from './importers/xlsx.js';

export default {
	csv:csv,
	json:json,
	array:array,
	xlsx:xlsx,
};